// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/Icons/accordionArrow.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* phone input field start */
.guideBookPhoneInput .react-tel-input .special-label {
    display: none;
}

.guideBookPhoneInput .react-tel-input {
    font-family: var(--font-family-base);
}

.guideBookPhoneInput .react-tel-input input[type="text"],
.guideBookPhoneInput .react-tel-input input[type="tel"] {
    border: 1px solid var(--primary-border);
    border-radius: var(--radius-1);
    height: 44px;
    width: 100%;
    padding-left: 84px;
    background: var(--primary-input-bg);
    margin-bottom: 0 !important;
    resize: none;
    z-index: 1;
    font-size: 16px !important;
    font-weight: 500;
    line-height: 26px;
    color: var(--primary-foreground);
    -webkit-appearance: none;
    appearance: none;
    outline: none;
}

.guideBookPhoneInput .react-tel-input input[type="text"]:disabled,
.guideBookPhoneInput .react-tel-input input[type="tel"]:disabled {
    background: var(--primary-disable);
}

.guideBookPhoneInput .react-tel-input input[type="text"]:focus,
.guideBookPhoneInput .react-tel-input input[type="tel"]:focus {
    border-color: var(--primary-border);
    box-shadow: unset;
    outline: unset;
}

.guideBookPhoneInput .react-tel-input .flag-dropdown {
    background: var(--primary-input-bg);
    border: 1px solid transparent;
    border-radius: var(--radius-1);
    width: 100%;
}

.guideBookPhoneInput .react-tel-input .selected-flag {
    width: 66px;
    padding: 0;
    border-radius: var(--radius-1) 0 0 var(--radius-1);
    border-right: 1px solid var(--primary-border);
    outline: none;
    z-index: 1;
}

.guideBookPhoneInput .react-tel-input .flag-dropdown.open .selected-flag {
    background: var(--primary-input-bg);
    border-radius: var(--radius-1) 0 0 var(--radius-1);
}

.guideBookPhoneInput .react-tel-input .flag-dropdown .selected-flag,
.guideBookPhoneInput .react-tel-input .flag-dropdown:hover .selected-flag,
.guideBookPhoneInput .react-tel-input .flag-dropdown:focus .selected-flag {
    background: var(--primary-input-bg);
}

.guideBookPhoneInput .react-tel-input .selected-flag .flag {
    left: 12px;
}

.guideBookPhoneInput .react-tel-input .selected-flag .arrow {
    border-left: 0px solid transparent;
    border-right: 0px solid transparent;
    border-top: 0px solid transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    width: 12px;
    height: 12px;
    background-repeat: no-repeat;
    background-size: contain;
    top: 2px;
    left: 24px;
    transform: rotate(180deg);
}

.guideBookPhoneInput .react-tel-input .selected-flag .arrow.up {
    border-bottom: 0px solid transparent;
    transform: rotate(0deg);
}

.guideBookPhoneInput .react-tel-input .country-list {
    width: 100%;
    box-shadow: unset;
    outline: unset;
    background-color: var(--primary-input-bg);
    border: 1px solid var(--primary-border);
    text-align: start;
    user-select: none;
    margin-top: 4px;
}

.guideBookPhoneInput .react-tel-input .country-list .country {
    color: var(--primary-foreground);
}

.guideBookPhoneInput .react-tel-input .country-list .country:hover,
.guideBookPhoneInput .react-tel-input .country-list .country.highlight {
    background-color: var(--common-hover-bg);
}

.guideBookPhoneInput .react-tel-input .flag-dropdown.open {
    width: 100%;
    background: var(--primary-input-bg);
    border-radius: var(--radius-1);
    z-index: unset;
}

.guideBookPhoneInput .react-tel-input .country-list .country .dial-code {
    color: var(--secondary-foreground);
}

.guideBookPhoneInput .react-tel-input input[type="text"]:disabled+.flag-dropdown {
    background-color: var(--primary-disable);
}

.guideBookPhoneInput .react-tel-input input[type="text"]:disabled+.flag-dropdown .selected-flag,
.guideBookPhoneInput .react-tel-input input[type="text"]:disabled+.flag-dropdown:hover .selected-flag,
.guideBookPhoneInput .react-tel-input input[type="text"]:disabled+.flag-dropdown:focus .selected-flag,
.guideBookPhoneInput .react-tel-input input[type="tel"]:disabled+.flag-dropdown .selected-flag,
.guideBookPhoneInput .react-tel-input input[type="tel"]:disabled+.flag-dropdown:hover .selected-flag,
.guideBookPhoneInput .react-tel-input input[type="tel"]:disabled+.flag-dropdown:focus .selected-flag {
    background: var(--primary-disable);
}

.guideBookPhoneInput .react-tel-input .country-list .country-name {
    display: inline-block;
}

/* phone input field end */

/* rtl */

.rtl .guideBookPhoneInput .react-tel-input input[type="text"],
.rtl .guideBookPhoneInput .react-tel-input input[type="tel"] {
    padding-left: 12px;
    padding-right: 83px;
    text-align: right;
}

.rtl .guideBookPhoneInput .react-tel-input .selected-flag {
    border-right: unset;
    border-left: 1px solid var(--primary-border);
}

.rtl .guideBookPhoneInput .react-tel-input .selected-flag .flag {
    right: 12px;
    left: unset;
}

.rtl .guideBookPhoneInput .react-tel-input .selected-flag .arrow {
    left: unset;
    right: 24px;
}

.rtl .guideBookPhoneInput .react-tel-input .selected-flag,
.rtl .guideBookPhoneInput .react-tel-input .flag-dropdown.open .selected-flag {
    border-radius: 0 var(--radius-1) var(--radius-1) 0;
}

.rtl .guideBookPhoneInput .react-tel-input .flag-dropdown.open {
    border-radius: var(--radius-1);
}

.rtl .guideBookPhoneInput .react-tel-input .country-list .flag {
    margin-left: 7px;
    margin-right: 0;
}

.rtl .guideBookPhoneInput .react-tel-input .selected-flag .arrow {
    left: -27px;
}

.rtl .guideBookPhoneInput .react-tel-input .country-list .country-name {
    margin-right: unset;
    margin-left: 6px;
}

.darkMode .guideBookPhoneInput .react-tel-input .selected-flag .arrow {
    filter: invert(91%) sepia(95%) saturate(47%) hue-rotate(196deg) brightness(100%) contrast(85%);
}`, "",{"version":3,"sources":["webpack://./src/styles/phoneNumberInput.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,uCAAuC;IACvC,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,mCAAmC;IACnC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kDAAkD;IAClD,6CAA6C;IAC7C,aAAa;IACb,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,kDAAkD;AACtD;;AAEA;;;IAGI,mCAAmC;AACvC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,iCAAiC;IACjC,yDAA8D;IAC9D,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,QAAQ;IACR,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,uCAAuC;IACvC,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;;;;;IAMI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,0BAA0B;;AAE1B,QAAQ;;AAER;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,8FAA8F;AAClG","sourcesContent":["/* phone input field start */\n.guideBookPhoneInput .react-tel-input .special-label {\n    display: none;\n}\n\n.guideBookPhoneInput .react-tel-input {\n    font-family: var(--font-family-base);\n}\n\n.guideBookPhoneInput .react-tel-input input[type=\"text\"],\n.guideBookPhoneInput .react-tel-input input[type=\"tel\"] {\n    border: 1px solid var(--primary-border);\n    border-radius: var(--radius-1);\n    height: 44px;\n    width: 100%;\n    padding-left: 84px;\n    background: var(--primary-input-bg);\n    margin-bottom: 0 !important;\n    resize: none;\n    z-index: 1;\n    font-size: 16px !important;\n    font-weight: 500;\n    line-height: 26px;\n    color: var(--primary-foreground);\n    -webkit-appearance: none;\n    appearance: none;\n    outline: none;\n}\n\n.guideBookPhoneInput .react-tel-input input[type=\"text\"]:disabled,\n.guideBookPhoneInput .react-tel-input input[type=\"tel\"]:disabled {\n    background: var(--primary-disable);\n}\n\n.guideBookPhoneInput .react-tel-input input[type=\"text\"]:focus,\n.guideBookPhoneInput .react-tel-input input[type=\"tel\"]:focus {\n    border-color: var(--primary-border);\n    box-shadow: unset;\n    outline: unset;\n}\n\n.guideBookPhoneInput .react-tel-input .flag-dropdown {\n    background: var(--primary-input-bg);\n    border: 1px solid transparent;\n    border-radius: var(--radius-1);\n    width: 100%;\n}\n\n.guideBookPhoneInput .react-tel-input .selected-flag {\n    width: 66px;\n    padding: 0;\n    border-radius: var(--radius-1) 0 0 var(--radius-1);\n    border-right: 1px solid var(--primary-border);\n    outline: none;\n    z-index: 1;\n}\n\n.guideBookPhoneInput .react-tel-input .flag-dropdown.open .selected-flag {\n    background: var(--primary-input-bg);\n    border-radius: var(--radius-1) 0 0 var(--radius-1);\n}\n\n.guideBookPhoneInput .react-tel-input .flag-dropdown .selected-flag,\n.guideBookPhoneInput .react-tel-input .flag-dropdown:hover .selected-flag,\n.guideBookPhoneInput .react-tel-input .flag-dropdown:focus .selected-flag {\n    background: var(--primary-input-bg);\n}\n\n.guideBookPhoneInput .react-tel-input .selected-flag .flag {\n    left: 12px;\n}\n\n.guideBookPhoneInput .react-tel-input .selected-flag .arrow {\n    border-left: 0px solid transparent;\n    border-right: 0px solid transparent;\n    border-top: 0px solid transparent;\n    background-image: url('../../public/Icons/accordionArrow.svg');\n    background-position: center;\n    width: 12px;\n    height: 12px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    top: 2px;\n    left: 24px;\n    transform: rotate(180deg);\n}\n\n.guideBookPhoneInput .react-tel-input .selected-flag .arrow.up {\n    border-bottom: 0px solid transparent;\n    transform: rotate(0deg);\n}\n\n.guideBookPhoneInput .react-tel-input .country-list {\n    width: 100%;\n    box-shadow: unset;\n    outline: unset;\n    background-color: var(--primary-input-bg);\n    border: 1px solid var(--primary-border);\n    text-align: start;\n    user-select: none;\n    margin-top: 4px;\n}\n\n.guideBookPhoneInput .react-tel-input .country-list .country {\n    color: var(--primary-foreground);\n}\n\n.guideBookPhoneInput .react-tel-input .country-list .country:hover,\n.guideBookPhoneInput .react-tel-input .country-list .country.highlight {\n    background-color: var(--common-hover-bg);\n}\n\n.guideBookPhoneInput .react-tel-input .flag-dropdown.open {\n    width: 100%;\n    background: var(--primary-input-bg);\n    border-radius: var(--radius-1);\n    z-index: unset;\n}\n\n.guideBookPhoneInput .react-tel-input .country-list .country .dial-code {\n    color: var(--secondary-foreground);\n}\n\n.guideBookPhoneInput .react-tel-input input[type=\"text\"]:disabled+.flag-dropdown {\n    background-color: var(--primary-disable);\n}\n\n.guideBookPhoneInput .react-tel-input input[type=\"text\"]:disabled+.flag-dropdown .selected-flag,\n.guideBookPhoneInput .react-tel-input input[type=\"text\"]:disabled+.flag-dropdown:hover .selected-flag,\n.guideBookPhoneInput .react-tel-input input[type=\"text\"]:disabled+.flag-dropdown:focus .selected-flag,\n.guideBookPhoneInput .react-tel-input input[type=\"tel\"]:disabled+.flag-dropdown .selected-flag,\n.guideBookPhoneInput .react-tel-input input[type=\"tel\"]:disabled+.flag-dropdown:hover .selected-flag,\n.guideBookPhoneInput .react-tel-input input[type=\"tel\"]:disabled+.flag-dropdown:focus .selected-flag {\n    background: var(--primary-disable);\n}\n\n.guideBookPhoneInput .react-tel-input .country-list .country-name {\n    display: inline-block;\n}\n\n/* phone input field end */\n\n/* rtl */\n\n.rtl .guideBookPhoneInput .react-tel-input input[type=\"text\"],\n.rtl .guideBookPhoneInput .react-tel-input input[type=\"tel\"] {\n    padding-left: 12px;\n    padding-right: 83px;\n    text-align: right;\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .selected-flag {\n    border-right: unset;\n    border-left: 1px solid var(--primary-border);\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .selected-flag .flag {\n    right: 12px;\n    left: unset;\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .selected-flag .arrow {\n    left: unset;\n    right: 24px;\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .selected-flag,\n.rtl .guideBookPhoneInput .react-tel-input .flag-dropdown.open .selected-flag {\n    border-radius: 0 var(--radius-1) var(--radius-1) 0;\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .flag-dropdown.open {\n    border-radius: var(--radius-1);\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .country-list .flag {\n    margin-left: 7px;\n    margin-right: 0;\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .selected-flag .arrow {\n    left: -27px;\n}\n\n.rtl .guideBookPhoneInput .react-tel-input .country-list .country-name {\n    margin-right: unset;\n    margin-left: 6px;\n}\n\n.darkMode .guideBookPhoneInput .react-tel-input .selected-flag .arrow {\n    filter: invert(91%) sepia(95%) saturate(47%) hue-rotate(196deg) brightness(100%) contrast(85%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
